module.exports = __webpack_public_path__ + "img/logo-primary.41d52a71.svg";